import React from 'react'
import './Head.scss'
// import { ReactComponent as HeadSVG } from './images/head.svg'
import head from './images/head.png'

const Head = (props) => {
    return props.isShow
        ? <div className='head'>
            {/* <HeadSVG width={props.width} height={props.height} /> */}
            <img src={head} alt='loading...' />
        </div> : null
}

export default Head